import type { Table } from "@tanstack/react-table";
import { getColumnWidth, isFixedSize } from "./styles";

interface SimpleTableColGroupProps<TData> {
  table: Table<TData>;
  respectColumnWidths: boolean;
}

export const SimpleTableColGroup = <TData,>({
  table,
  respectColumnWidths,
}: SimpleTableColGroupProps<TData>) => {
  const flatHeaders = table.getHeaderGroups()[0]?.headers ?? [];
  const hasPinnedColumns = flatHeaders.some((h) => h.column.getIsPinned());

  return (
    <colgroup>
      {flatHeaders.map((header) => (
        <col
          key={header.id}
          style={{
            width:
              respectColumnWidths ||
              header.column.getIsPinned() ||
              !hasPinnedColumns ||
              isFixedSize(header.column)
                ? getColumnWidth(header.column)
                : undefined,
          }}
        />
      ))}
    </colgroup>
  );
};
